var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
function SvgError(props) {
    return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "17", viewBox: "0 0 16 17", fill: "none" }, props, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.99992 1.83331C4.31325 1.83331 1.33325 4.81331 1.33325 8.49998C1.33325 12.1866 4.31325 15.1666 7.99992 15.1666C11.6866 15.1666 14.6666 12.1866 14.6666 8.49998C14.6666 4.81331 11.6866 1.83331 7.99992 1.83331ZM7.99993 7.55996L10.3933 5.16663L11.3333 6.10663L8.93993 8.49996L11.3333 10.8933L10.3933 11.8333L7.99993 9.43996L5.6066 11.8333L4.6666 10.8933L7.05993 8.49996L4.6666 6.10663L5.6066 5.16663L7.99993 7.55996Z", fill: "#CD261D" }) })));
}
export default SvgError;
